import { ThingIt } from "@thing-it/client-api";
import html2canvas from "html2canvas";
import $ from "jquery";

/**
 * Broadcast screenshot to ThingIt parent page
 */
export default () => {
  if (window.__CFG__.isLocal == 1) {
    return false;
  }

  var t;
  const thingItInstance = new ThingIt();
  const body = window.self.document.body;
  takeScreenshot();

  function takeScreenshot() {
    clearInterval(t);
    setTimeout(function () {
      capture();
    }, 2000);

    const capture = async () => {
      try {
        const ctx = await html2canvas(body);
        if ($(ctx).attr("width") == 0) {
          return;
        }

        const dataUrl = ctx.toDataURL();
        thingItInstance.broadcastScreenshot(dataUrl);
      } catch (e) {
        console.warn("Unable to capture page");
      }
    };

    t = setInterval(takeScreenshot, 300000);
  }
};
